import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { ClientAttachmentId, isClientAttachmentIdEqual } from 'owa-client-ids';

export default function getAttachmentViewStateFromAttachmentWell(
    attachmentWell: AttachmentWellViewState,
    attachmentId: ClientAttachmentId
): AttachmentFullViewState {
    return (
        getAttachmentViewStateFromAttachments(attachmentWell.docViewAttachments, attachmentId) ||
        getAttachmentViewStateFromAttachments(attachmentWell.imageViewAttachments, attachmentId)
    );
}

function getAttachmentViewStateFromAttachments(
    attachments: AttachmentFullViewState[],
    attachmentId: ClientAttachmentId
): AttachmentFullViewState {
    const [viewState] = attachments.filter(attachment =>
        isClientAttachmentIdEqual(attachment.attachmentId, attachmentId)
    );
    return viewState;
}
